export * from './gql/document-gql';
export * from './gql/digital-verification/signature-gql';
